waitForElementToRender('inbox-online-store-chat').then(async (chatButton) => {
  chatButton.classList.add('!min-w-[72px]');
  chatButton.classList.add('!z-fixed');

  // Check if on product page and screen is small
  if (chatButton && window.location.pathname.includes('/products/') && window.innerWidth < 768) {
    const stickyAddToCart = document.querySelector('sticky-add-to-cart');
    const atcFormButtons = stickyAddToCart?.querySelector('.product-form__buttons');
    const stickyButton = stickyAddToCart?.querySelector('[data-sticky-add-to-cart]');

    checkElement('inbox-online-store-chat').then((chatButton) => {
      const checkExist = setInterval(() => {
        let shadowButton = chatButton?.shadowRoot?.querySelector('button');

        if (shadowButton) {
          // Get height of button
          let shadowButtonStyles = window.getComputedStyle(shadowButton);
          let shadowButtonHeight =
            shadowButton.offsetHeight +
            parseInt(shadowButtonStyles.marginTop) +
            parseInt(shadowButtonStyles.marginBottom);

          if (chatButton.getAttribute('button-vertical-position') === 'lowest') {
            atcFormButtons.setAttribute('style', `--height: ${chatButton.clientHeight}px;`);
            stickyButton.parentElement.setAttribute('style', `--height:${shadowButtonHeight}px`);
            stickyButton.parentElement.classList.add('flex', 'items-center');

            if (chatButton.getAttribute('button-position') === 'bottom_left')
              stickyButton.classList.add('justify-self-end');
            if (chatButton.getAttribute('button-position') === 'bottom_right')
              stickyButton.classList.add('justify-self-start');
          }
          clearInterval(checkExist);
        }
      }, 100); // check every 100ms
    });
  }
});
